// Почему приглашение в первый рейтинговый матч показывается сейчас — уровень
// события показа (page:RankedMatchPromoModal:mount:<reason>)
export const RANKED_MATCH_PROMO_REASONS = {
  // Первый показ на устройстве: сетевой матч только что появился в профиле
  FIRST: 'first',
  // Повторный: рейтингового матча так и нет
  REMINDER: 'reminder',
};

/**
 * Показывать ли приглашение в первый рейтинговый матч (RankedMatchPromoModal)
 * и по какой причине; null — не показывать.
 *
 * Адресат — игрок, который уже сыграл хотя бы один сетевой матч (обычный),
 * но ни одного рейтингового. Оба счетчика приходят из профиля; null — «сервер
 * не прислал» (старая сборка), и тогда молчим: без точного знания звать в
 * «первый» рейтинговый матч нельзя. Прохождение обучения не требуется —
 * обычный матч можно сыграть и без него. Показ не чаще раза в сутки (isDue);
 * первый показ наступает сразу, как только условие выполнилось, — счетчик
 * сетевых матчей после партии двигается локально (см.
 * getOwnMatchResultProfileActions), и приглашение ждет игрока уже при
 * возвращении в меню.
 *
 * @param {Object} params
 * @param {number|null} params.onlineGamesPlayed - сыгранные сетевые матчи (все)
 * @param {number|null} params.rankedGamesPlayed - из них рейтинговые
 * @param {boolean} params.isDue - суточная пауза с прошлого показа прошла
 * @param {boolean} params.isEverShown - показывали ли уже на этом устройстве
 * @returns {string|null} причина из RANKED_MATCH_PROMO_REASONS или null
 */
export const resolveRankedMatchPromoReason = ({
  onlineGamesPlayed,
  rankedGamesPlayed,
  isDue,
  isEverShown,
}) => {
  if (!(onlineGamesPlayed > 0) || rankedGamesPlayed !== 0 || !isDue) {
    return null;
  }
  return isEverShown ? RANKED_MATCH_PROMO_REASONS.REMINDER : RANKED_MATCH_PROMO_REASONS.FIRST;
};
